import React, { useState } from 'react';
import Markdown from 'markdown-to-jsx';
import { BsStars } from 'react-icons/bs';
import { ForgeIcon } from '@tylertech/forge-react';
import { addTargetBlanktoLinks } from '../../api/helpers';
import { isVif, RenderMode } from '../../types';
var FeedbackStates;
(function (FeedbackStates) {
    FeedbackStates["NONE"] = "none";
    FeedbackStates["THUMBS_UP"] = "THUMBS_UP";
    FeedbackStates["THUMBS_DOWN"] = "THUMBS_DOWN";
})(FeedbackStates || (FeedbackStates = {}));
const Response = ({ mode, renderMode, message }) => {
    const [feedbackState, setFeedbackState] = useState(FeedbackStates.NONE);
    if (isVif(mode) && message.response === '') {
        return null;
    }
    const handleFeedback = (newFeedbackState) => {
        if ([FeedbackStates.THUMBS_UP, FeedbackStates.THUMBS_DOWN].includes(newFeedbackState) && newFeedbackState === feedbackState) {
            setFeedbackState(FeedbackStates.NONE);
        }
        else {
            setFeedbackState(newFeedbackState);
        }
    };
    const renderedMessageContent = (() => {
        const { response } = message;
        if (response.includes('<') && response.includes('>')) {
            return React.createElement("div", { className: "stream-response", dangerouslySetInnerHTML: { __html: response } });
        }
        else if (/\.(jpeg|jpg|gif|png|svg)(\?.*)?$/i.test(response)) {
            return (React.createElement("div", { className: "stream-response" },
                React.createElement("img", { src: response, alt: "Response" })));
        }
        else {
            const markdownWithNewTabLinks = addTargetBlanktoLinks(response);
            return (React.createElement("div", { className: "stream-response" },
                renderMode === RenderMode.FLOATING && React.createElement(BsStars, { className: "chatbot-input-icon" }),
                React.createElement(Markdown, null, markdownWithNewTabLinks)));
        }
    })();
    const isThumbsUpFeedback = feedbackState === FeedbackStates.THUMBS_UP;
    const isThumbsDownFeedback = feedbackState === FeedbackStates.THUMBS_DOWN;
    return (React.createElement("div", { className: "ai-response-container" },
        React.createElement("div", { className: "ai-response" },
            renderedMessageContent,
            React.createElement("div", { className: "feedback-icons" },
                React.createElement("span", { className: `thumbsup ${isThumbsUpFeedback ? 'clicked' : 'none'}`, onClick: () => handleFeedback(FeedbackStates.THUMBS_UP) }, isThumbsUpFeedback ? React.createElement(ForgeIcon, { name: "thumb_up_alt" }) : React.createElement(ForgeIcon, { name: "thumb_up_off_alt" })),
                React.createElement("span", { className: `thumbsdown ${isThumbsDownFeedback ? 'clicked' : 'none'}`, onClick: () => handleFeedback(FeedbackStates.THUMBS_DOWN) }, isThumbsDownFeedback ? React.createElement(ForgeIcon, { name: "thumb_down_alt" }) : React.createElement(ForgeIcon, { name: "thumb_down_off_alt" }))))));
};
export default Response;
//# sourceMappingURL=Response.js.map